import React from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

import servicioObjetos from "../../servicio/ServicioObjetos";

const MENSAJE_ENTIEMPO = "Movimiento enviado en tiempo";
const MENSAJE_48HORAS = "Movimiento enviado dentro de las 48 horas";
const MENSAJE_MAYOR3_4DIAS = "Movimiento enviado fuera de nuestros lineamientos";
const MENSAJE_FUERA_LINEAMIENTOS = "Movimiento enviado en el límite de tiempo y fuera de nuestros lineamientos ¿Deseas continuar?";
const ROJO = "#ff0000";
const NARANJA = "#ffa500";
const AMARILLO = "#ffff00";
const VERDE = "#008000";
export const TablaDetalleMovsEnvio = (props) => {

    const { datos } = props;

    const plantillaIconoValido = (rowData, column) => {
        let existeDetalle = (rowData.observacionRegistroPatronal === null && rowData.observacionNumeroSeguroSocial === null && rowData.observacionDigitoVerificador === null && rowData.observacionPrimerApellido === null && rowData.observacionSegundoApellido === null && rowData.observacionNombre === null && rowData.observacionSalarioBase === null && rowData.observacionTipoTrabajador === null && rowData.observacionTipoSalario === null && rowData.observacionJornadaReducida === null && rowData.observacionFechaMovimiento === null && rowData.observacionUmf === null && rowData.observacionNumeroGuia === null && rowData.observacionClaveTrabajador === null && rowData.observacionCurp === null && rowData.observacionUltimiDigito === null && rowData.observacionTipoMovimiento === null && rowData.observacionCausaBaja === null);
        return (<div className="p-grid">
            <div className="p-col-12 p-md-2">
                <Button
                    type="button"
                    icon={existeDetalle ? "pi-md-check-circle" : "pi-md-check-circle pi pi-times"}
                    className={existeDetalle ? "p-button-success" : "p-button-danger"}
                    name="estatus de linea"
                    tooltip="Estatus de linea"
                ></Button>
            </div>
        </div>);
    }

    const plantillaErrorRegistroPatronal = (rowData, column) => {
        if (servicioObjetos.esObjetoVacio()) {
            return <p >{rowData.registroPatronal}</p>
        } else {
            return <p>{rowData.registroPatronal + " " + rowData.observacionRegistroPatronal}</p>
        }
    }

    const plantillaErrorNumeroSeguroSocial = (rowData, column) => {
        if (servicioObjetos.esObjetoVacio(rowData.observacionNumeroSeguroSocial)) {
            return <p >{rowData.numeroSeguroSocial}</p>
        } else {
            return <p style={{ color: '#FF334F' }}>{rowData.numeroSeguroSocial + " " + rowData.observacionNumeroSeguroSocial}</p>
        }
    }

    const plantillaErrorDigitoVerificador = (rowData, column) => {
        if (rowData.observacionDigitoVerificador != null)
            return <p style={{ color: '#FF334F' }}>{rowData.digitoVerificador + " " + rowData.observacionDigitoVerificador}</p>

        else
            return <p >{rowData.digitoVerificador}</p>
    }

    const plantillaErrorApellidoPaterno = (rowData, column) => {
        if (rowData.observacionPrimerApellido != null)
            return <p style={{ color: '#FF334F' }}>{rowData.primerApellido + " " + rowData.observacionPrimerApellido}</p>

        else
            return <p>{rowData.primerApellido}</p>
    }

    const plantillaErrorApellidoMaterno = (rowData, column) => {
        if (rowData.observacionSegundoApellido != null)
            return <p style={{ color: '#FF334F' }}>{rowData.segundoApellido + " " + rowData.observacionSegundoApellido}</p>

        else
            return <p >{rowData.segundoApellido}</p>
    }

    const plantillaErrorNombre = (rowData, column) => {

        if (rowData.observacionNombre != null)
            return <p style={{ color: '#FF334F' }}>{rowData.nombre + " " + rowData.observacionNombre}</p>

        else
            return <p>{rowData.nombre}</p>

    }

    const plantillaErrorSalarioBase = (rowData, column) => {
        if (rowData.observacionSalarioBase != null)
            return <p style={{ color: '#FF334F' }}>{rowData.salarioBase + " " + rowData.observacionSalarioBase}</p>

        else
            return <p>{rowData.salarioBase}</p>
    }

    const plantillaErrorTipoTrabajador = (rowData, column) => {
        if (rowData.observacionTipoTrabajador != null)
            return <p style={{ color: '#FF334F' }}>{rowData.tipoTrabajador + " " + rowData.observacionTipoTrabajador}</p>

        else
            return <p>{rowData.tipoTrabajador}</p>
    }

    const plantillaErrorTipoSalario = (rowData, column) => {
        if (rowData.observacionTipoSalario != null)
            return <p style={{ color: '#FF334F' }}>{rowData.tipoSalario + " " + rowData.observacionTipoSalario}</p>

        else
            return <p>{rowData.tipoSalario}</p>
    }


    const plantillaErrorSemanaJornadaReducida = (rowData, column) => {
        if (rowData.observacionJornadaReducida != null)
            return <p style={{ color: '#FF334F' }}>{rowData.semanaJornadaReducida + " " + rowData.observacionJornadaReducida}</p>

        else
            return <p >{rowData.semanaJornadaReducida}</p>
    }

    const plantillaErrorFechaMovimiento = (rowData, column) => {
        if (rowData.observacionFechaMovimiento != null)
            return <p style={{ color: '#FF334F' }}>{rowData.fechaMovimiento + " " + rowData.observacionFechaMovimiento}</p>
        else
            return <p >{rowData.fechaMovimiento}</p>
    }


    const plantillaErrorUmf = (rowData, column) => {
        if (rowData.observacionUmf != null)
            return <p style={{ color: '#FF334F' }}>{rowData.umf + " " + rowData.observacionUmf}</p>

        else
            return <p>{rowData.umf}</p>
    }

    const plantillaErrorNumeroGuia = (rowData, column) => {
        if (rowData.observacionNumeroGuia != null)
            return <p style={{ color: '#FF334F' }}>{rowData.numeroGuia + " " + rowData.observacionNumeroGuia}</p>

        else
            return <p>{rowData.numeroGuia}</p>
    }

    const plantillaErrorClaveTrabajador = (rowData, column) => {
        if (rowData.observacionClaveTrabajador != null)
            return <p style={{ color: '#FF334F' }}>{rowData.claveTrabajador + " " + rowData.observacionClaveTrabajador}</p>

        else
            return <p>{rowData.claveTrabajador}</p>
    }

    const plantillaErrorCurp = (rowData, column) => {
        if (rowData.observacionCurp != null)
            return <p style={{ color: '#FF334F' }}>{rowData.curp + " " + rowData.observacionCurp}</p>

        else
            return <p>{rowData.curp}</p>
    }

    const plantillaErrorCausaBaja = (rowData, column) => {
        if (rowData.observacionCausaBaja != null)
            return <p style={{ color: '#FF334F' }}>{rowData.causaBaja + " " + rowData.observacionCausaBaja}</p>

        else
            return <p>{rowData.causaBaja}</p>
    }

    const plantillaErrorTipoMovimiento = (rowData, column) => {
        if (rowData.observacionTipoMovimiento != null)
            return <p style={{ color: '#FF334F' }}>{rowData.tipoMovimiento + " " + rowData.observacionTipoMovimiento}</p>

        else
            return <p >{rowData.tipoMovimiento}</p>
    }

    const plantillaErrorLinea = (rowData, column) => {
        if (rowData.observacionLinea != null)
            return <p style={{ color: '#FF334F' }}>{rowData.observacionLinea}</p>
    }

    const plantillaErrorUltimoDigito = (rowData, column) => {
        if (rowData.observacionUltimiDigito != null)
            return <p style={{ color: '#FF334F' }}>{rowData.ultimoDigito + " " + rowData.observacionUltimiDigito}</p>

        else
            return <p >{rowData.ultimoDigito}</p>
    }

    const plantillaObservacionTiempo = (rowData, column) => {
        let color = "";
        if (rowData.observacionEnTiempoFechaMovimiento === MENSAJE_ENTIEMPO)
            color = VERDE;
        if (rowData.observacionEnTiempoFechaMovimiento === MENSAJE_48HORAS)
            color = AMARILLO;
        if (rowData.observacionEnTiempoFechaMovimiento === MENSAJE_MAYOR3_4DIAS)
            color = NARANJA;
        if (rowData.observacionEnTiempoFechaMovimiento === MENSAJE_FUERA_LINEAMIENTOS)
            color = ROJO;
        return <p style={{ backgroundColor: color, borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>{rowData.observacionEnTiempoFechaMovimiento}</p>
    }

    const headerTemplate = (data) => {
        return <strong>* Nombre del archivo: {data.nombreArchivo}</strong>;
    };

    const footerTemplate = (data, index) => {
        return (
                <td  colSpan={24} style={{'border-top': '8px solid #bbb',
  'border-radius': '5px',width:'100%'}}></td>
        );
    };

    return (<div>
        <DataTable value={datos} responsive={true} header={"Movimientos a enviar"}
            paginator={true}
            rows={20}
            autoLayout={true}
            rowGroupMode="subheader" sortField="nombreArchivo" sortOrder={1} groupField="nombreArchivo"
            rowGroupHeaderTemplate={headerTemplate}
            rowGroupFooterTemplate={footerTemplate}>            
            <Column header="Linea" field="numeroLinea" />
            <Column header="Estatus" body={plantillaIconoValido} />
            <Column header="Nombre Archivo" field="nombreArchivo" />
            <Column header="Observación en tiempo" body={plantillaObservacionTiempo} />
            <Column body={plantillaErrorRegistroPatronal} header="Registro Patronal" />
            <Column body={plantillaErrorNumeroSeguroSocial} header="Número seguro social" />
            <Column body={plantillaErrorDigitoVerificador} header="Dígito Verificador" />
            <Column body={plantillaErrorApellidoPaterno} header="Primer Apellido" />
            <Column body={plantillaErrorApellidoMaterno} header="Segundo Apellido" />
            <Column body={plantillaErrorNombre} header="Nombre" />
            <Column body={plantillaErrorSalarioBase} header="Salario Base" />
            <Column body={plantillaErrorTipoTrabajador} header="Tipo trabajador" />
            <Column body={plantillaErrorTipoSalario} header="Tipo Salario" />
            <Column body={plantillaErrorSemanaJornadaReducida} header="Jornada Reducida" />
            <Column body={plantillaErrorFechaMovimiento} header="Fecha Movimiento" />
            <Column body={plantillaErrorUmf} header="UMF" />
            <Column body={plantillaErrorNumeroGuia} header="Numero Guia" />
            <Column body={plantillaErrorClaveTrabajador} header="Clave Trabajador" />
            <Column body={plantillaErrorCurp} header="CURP" />
            <Column body={plantillaErrorCausaBaja} header="Causa Baja" />
            <Column body={plantillaErrorTipoMovimiento} header="Tipo Movimiento" />
            <Column body={plantillaErrorLinea} header="Formato" />
            <Column body={plantillaErrorUltimoDigito} header="Identificador del formato" />
        </DataTable>
    </div>);
}